"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showHubspotShareOverlay = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var SharePopover_1 = require("Project/SharePopover/SharePopover");
var Configuration_1 = require("Styles/Configuration/Configuration");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
function showHubspotShareOverlay(projectStore, di) {
    var mountReactComponent = di.get("mountReactComponent");
    var usingFeature = di.get("usingFeature");
    var overlayStack = di.get("overlayStack");
    var $timeout = di.get("$timeout");
    var close = function () {
        $timeout(function () {
            overlayStack.closeCurrent();
        });
    };
    var ui = mountReactComponent(react_1.default.createElement(HubspotShareLayout, { projectStore: projectStore, usingFeature: usingFeature, close: close }));
    $timeout(function () {
        overlayStack.add({ contentUi: ui, options: { externalClass: "hubspot", centerContent: false } });
        overlayStack.usingCustomCloseButton();
    });
}
exports.showHubspotShareOverlay = showHubspotShareOverlay;
var c = (0, BemBuilder_1.default)("hubspot-share-layout");
var HubspotShareLayout = function (_a) {
    var projectStore = _a.projectStore, usingFeature = _a.usingFeature, close = _a.close;
    return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.overlayStackZIndex }, function () { return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement("div", { className: c("wrapper") },
            react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), size: kaleidoscope_1.ButtonSize.Medium, onClick: close, className: c("close-button") }),
            react_1.default.createElement("div", { className: c("popover-container") },
                react_1.default.createElement(SharePopover_1.SharePopover, { projectStore: projectStore, usingFeature: usingFeature, source: TelemetryEnums_1.TelemetrySource.Hubspot, onDefaultLinkPreviewClick: close }))))); }));
};
